import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        user: {
            'credit_6': 0, 
            'credit_12': 10, 
            wish_list: [
                
            ],
            cart: [
              
            ],
            payment_terms: {
                credit_6: null,
                credit_12: null,
                total_credit: null,
                chosen_period: null, // 0 is cash, 6 and 12 are months
                credit_status: null, // "approved", "pending" - pending approval, "docs_required" -need to uplaod docs, null - user has not applied yet
            },
        },
        voucher: {
            code: '',
            value: 0.00,
            status: null,
            message: ''
        },
        search_results: {
            products: [],
            buyers_guides: [],
            categories: [],
            brands: [],
            search_string: null,
        },
        site: {
            currency: 'R',
            country: 'South Africa',
        },
        components: {
            mobile_search_button: {
                show_search: false,
            }
        },
        selected_product: {
            // sku: 333,
            // title: 'Other 14-piece',
            // slug: 'other-14-piece',
            // image: 'http://morganfillman.space/157/157',
            // modifiers: {'size':'Queen','color':'Blue'},
            // quantity: 1,
            // stock: 30,
            // price: 250,
            //price_6: 50.00,
            //price_12: 27.00,
            //price_cash: 250.00,
        }
    },
    getters: getters,
    mutations : mutations,
    actions: actions
});




// WEBPACK FOOTER //
// ./assets/js/vue/store/_store.js